module.exports = "<button [disabled]=\"disabled\" (click)=\"onBtnClick($event)\" class=\"btn {{cssClass}}\">    \r\n  <ng-content></ng-content>\r\n</button>"